<template>
    <el-drawer
        title="新增/编辑事件"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content">
            <el-form
                :model="formData"
                :rules="rules"
                ref="formData"
                label-position="top"
                size="medium"
            >
                
                <el-form-item prop="eventId" label="事件标识:">
                    <el-input v-model="formData.eventId" placeholder="请输入事件标识" maxlength="60"></el-input>
                    <div class="color-info">
                        仅能输入数字、字母、下划线
                    </div>
                </el-form-item>
                <el-form-item prop="eventName" label="事件名称:">
                    <el-input v-model="formData.eventName" placeholder="请输入事件名称" maxlength="40"></el-input>
                </el-form-item>
                <el-form-item prop="actionType" label="行为类型:">
                    <el-select v-model="formData.actionType" placeholder="请选择行为类型">
                        <el-option v-for="item in actionTypeList" :label="item.label" :key="item.value" :value="item.label"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="isOnline" label="是否上线:" required>
                    <el-select v-model="formData.isOnline">
                        <el-option label="已上线" :value="1"></el-option>
                        <el-option label="未上线" :value="0"></el-option>
                    </el-select>
                    <div class="color-info">
                        该属性仅用于人工标识事件是否已经上线
                    </div>
                </el-form-item>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading"
                >确认</el-button
            >
        </div>
    </el-drawer>
</template>
<script>
const defaultData = {
    actionType: "",
    eventId: "",
    eventName: "",
    isOnline: 1
}
export default {
    props:{
        actionTypeList:{
            type: Array,
            default: () => []
        }
    },
    data(){
        var validateEventId = (rule, value, callback) => {
            if (!value) {
                callback(new Error("请输入事件标识"));
            } else if (!/^[a-zA-Z0-9_]+$/.test(value)) {
                callback(new Error("事件标识只能输入数字、字母、下划线"));
            } else {
                callback();
            }
        };
        return{
            drawerShow: false,
            btnLoading: false,
            formData:{
                ...defaultData
            },
            rules:{
                eventId:[{ required: true, message: "请输入事件标识" },{validator: validateEventId}],
                eventName:[{ required: true, message: "请输入事件名称" }],
                actionType:[{ required: true, message: "请选择行为类型" }],
            },
        }
    },
    methods:{
        close(){
            this.$refs.formData.resetFields();
            this.drawerShow = false;
            this.formData = {
                ...defaultData
            }
        },
        show(_data){
            if( _data ){
                this.formData = Object.assign(defaultData, _data);
            }
            this.drawerShow = true;
        },
        submitForm(){
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;    
                    this.$request({
                        url: '/eventManage/save',
                        data: {...this.formData},
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg } = res.data;
                            if (state == 1) {
                                this.$emit('onUpdate');
                                this.close();
                            } else {
                                this.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            this.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });   
                } else {
                    return false;
                }
            });
        }
    }
}
</script>

<style lang="scss" scoped>

</style>